const _import = require('../import-' + process.env.NODE_ENV)

const checkinRouter = [
  {
    path: '/checkin/depart',
    name: 'checkinDepart',
    component: _import('checkin/depart'),
    meta: {
      auth: true,
      title: '扫码签到'
    }
  },
  {
    path: '/checkin/checkinLogs',
    name: 'checkinLogs',
    component: _import('checkin/checkinLogs'),
    meta: {
      auth: true,
      title: '签到本'
    }
  }
]
export default checkinRouter



// WEBPACK FOOTER //
// ./src/router/other/checkin.js